import {styled, getFont} from "@core-ui/react-stitch";
import {DrawerProps} from "../types";

type ContentProps = Pick<DrawerProps, "crossBrand">;

export const Content = styled.div<ContentProps>`
  ${getFont("primary")}
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  align-content: flex-end;
`;
